import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { fetchProgramList } from '../redux/actions/Actions';

const StudentDashboard = () => {
  const dispatch        = useDispatch();
  const navigate        = useNavigate();
  const { user, isAuthenticated } = useSelector((s) => s.auth);
  const programs        = useSelector((s) => s.fetchAllPrograms.programs) || [];
  const [editing, setEditing] = useState(false);

  useEffect(() => { dispatch(fetchProgramList()); }, [dispatch]);
  useEffect(() => { if (!isAuthenticated) navigate('/login'); }, [isAuthenticated]);

  const name     = user?.username || user?.name  || 'Student';
  const email    = user?.email    || '—';
  const phone    = user?.phone_number || user?.phone || '—';
  const role     = user?.role_id === 2 ? 'Student' : user?.role_id === 4 ? 'Member' : 'Student';
  const initials = name.split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2);

  const profileFields = [
    { icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#2563EB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>, label: 'Full Name',    value: name  },
    { icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#2563EB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>, label: 'Email',       value: email },
    { icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#2563EB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81a19.79 19.79 0 01-3.07-8.67A2 2 0 012 1h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.91 8.91a16 16 0 006.09 6.09l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/></svg>, label: 'Phone',       value: phone },
    { icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#2563EB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 10v6M2 10l10-5 10 5-10 5z"/><path d="M6 12v5c3 3 9 3 12 0v-5"/></svg>, label: 'Role',        value: role  },
  ];

  const quickActions = [
    { label: 'Browse Programs',  to: '/programs',          icon: <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#2563EB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 3h6a4 4 0 014 4v14a3 3 0 00-3-3H2z"/><path d="M22 3h-6a4 4 0 00-4 4v14a3 3 0 013-3h7z"/></svg> },
    { label: 'Masterclass',      to: '/masterclass',        icon: <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#2563EB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="23 7 16 12 23 17 23 7"/><rect x="1" y="5" width="15" height="14" rx="2" ry="2"/></svg> },
    { label: 'Request Callback', to: '/request-callback',   icon: <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#2563EB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81a19.79 19.79 0 01-3.07-8.67A2 2 0 012 1h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.91 8.91a16 16 0 006.09 6.09l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/></svg> },
  ];

  return (
    <div style={s.page}>

      <div style={s.content}>

        {/* ── Quick Actions ── */}
        <div style={s.quickSection}>
          <h2 style={s.sectionTitle}>Quick Actions</h2>
          <div style={s.quickGrid}>
            {quickActions.map((q) =>
              q.href ? (
                <a key={q.label} href={q.href} target="_blank" rel="noopener noreferrer" style={s.quickCard}
                  onMouseEnter={e => { e.currentTarget.style.borderColor='#2563EB'; e.currentTarget.style.transform='translateY(-3px)'; e.currentTarget.style.boxShadow='0 6px 20px rgba(37,99,235,0.13)'; }}
                  onMouseLeave={e => { e.currentTarget.style.borderColor='#E2E8F0'; e.currentTarget.style.transform='none'; e.currentTarget.style.boxShadow='0 2px 8px rgba(0,0,0,0.05)'; }}>
                  <div style={s.quickIconWrap}>{q.icon}</div>
                  <span style={s.quickLabel}>{q.label}</span>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#CBD5E1" strokeWidth="2" style={{ marginLeft:'auto', flexShrink:0 }}><polyline points="9 18 15 12 9 6"/></svg>
                </a>
              ) : (
                <Link key={q.label} to={q.to} style={s.quickCard}
                  onMouseEnter={e => { e.currentTarget.style.borderColor='#2563EB'; e.currentTarget.style.transform='translateY(-3px)'; e.currentTarget.style.boxShadow='0 6px 20px rgba(37,99,235,0.13)'; }}
                  onMouseLeave={e => { e.currentTarget.style.borderColor='#E2E8F0'; e.currentTarget.style.transform='none'; e.currentTarget.style.boxShadow='0 2px 8px rgba(0,0,0,0.05)'; }}>
                  <div style={s.quickIconWrap}>{q.icon}</div>
                  <span style={s.quickLabel}>{q.label}</span>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#CBD5E1" strokeWidth="2" style={{ marginLeft:'auto', flexShrink:0 }}><polyline points="9 18 15 12 9 6"/></svg>
                </Link>
              )
            )}
          </div>
        </div>

        <div style={{ ...s.twoCol, gridTemplateColumns: '1fr' }}>

          {/* ── Programs ── */}
          <div>
            <div style={s.sectionRow}>
              <h2 style={s.sectionTitle}>Explore Programs</h2>
              <Link to="/programs" style={s.viewAll}>View all →</Link>
            </div>
            <div style={s.programGrid}>
              {programs.slice(0, 6).map((p) => (
                <Link key={p.program_id} to={`/programDetail/${p.program_id}`} style={s.programCard}
                  onMouseEnter={e => { e.currentTarget.style.borderColor='#2563EB'; e.currentTarget.style.transform='translateY(-3px)'; }}
                  onMouseLeave={e => { e.currentTarget.style.borderColor='#E2E8F0'; e.currentTarget.style.transform='none'; }}>
                  <div style={s.programAccent} />
                  <div style={s.programBody}>
                    <div style={s.programDuration}>{p.duration || 'Flexible'}</div>
                    <h3 style={s.programName}>{p.program_name}</h3>
                    <div style={s.programFooter}>
                      <span style={s.programCost}>{p.cost ? `₹${Number(p.cost).toLocaleString()}` : 'Contact us'}</span>
                      <span style={s.programLink}>View →</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

const s = {
  page: { fontFamily: "'Inter','Segoe UI',sans-serif", background: '#F8FAFC', minHeight: '100vh' },

  /* Quick actions */
  quickSection: { marginBottom: 32 },
  quickGrid: { display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 20, marginTop: 16 },
  quickCard: {
    display: 'flex', alignItems: 'center', gap: 20,
    background: '#fff', border: '1.5px solid #E2E8F0', borderRadius: 18,
    padding: '28px 28px', textDecoration: 'none', cursor: 'pointer',
    boxShadow: '0 2px 8px rgba(0,0,0,0.05)', transition: 'all 0.2s',
  },
  quickIconWrap: {
    width: 60, height: 60, borderRadius: 16, background: '#EFF6FF',
    border: '1px solid #BFDBFE', display: 'flex', alignItems: 'center',
    justifyContent: 'center', flexShrink: 0,
  },
  quickLabel: { fontSize: 17, fontWeight: 700, color: '#0F172A', flex: 1 },

  banner: {
    background: 'linear-gradient(135deg,#0D9488 0%,#0EA5E9 45%,#2563EB 100%)',
    padding: '48px 5% 40px',
  },
  bannerInner: { display: 'flex', alignItems: 'center', gap: 20, marginBottom: 36 },
  avatar: {
    width: 64, height: 64, borderRadius: '50%',
    background: 'rgba(255,255,255,0.25)', border: '2px solid rgba(255,255,255,0.5)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: 24, fontWeight: 800, color: '#fff', flexShrink: 0,
  },
  welcomeLabel: { fontSize: 13, color: 'rgba(255,255,255,0.7)', fontWeight: 500, margin: '0 0 4px' },
  welcomeName:  { fontSize: 'clamp(20px,3vw,32px)', fontWeight: 800, color: '#fff', margin: '0 0 4px', letterSpacing: '-0.02em' },
  welcomeEmail: { fontSize: 13, color: 'rgba(255,255,255,0.65)', margin: 0 },
  statsRow: { display: 'flex', gap: 12, flexWrap: 'wrap' },
  statCard: {
    background: 'rgba(255,255,255,0.12)', border: '1px solid rgba(255,255,255,0.2)',
    borderRadius: 12, padding: '14px 22px', backdropFilter: 'blur(4px)',
    display: 'flex', flexDirection: 'column', gap: 3,
  },
  statV: { fontSize: 22, fontWeight: 800, color: '#fff', letterSpacing: '-0.02em' },
  statL: { fontSize: 11, color: 'rgba(255,255,255,0.65)', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.06em' },

  content: { maxWidth: 1200, margin: '0 auto', padding: '36px 5% 80px' },
  twoCol:  { display: 'grid', gridTemplateColumns: '340px 1fr', gap: 32, alignItems: 'start' },

  /* Profile card */
  profileCard: {
    background: '#fff', border: '1px solid #E2E8F0', borderRadius: 16,
    padding: '28px 28px 24px', boxShadow: '0 2px 12px rgba(37,99,235,0.07)',
    position: 'sticky', top: 80,
  },
  cardHeader: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 24 },
  cardTitle:  { fontSize: 17, fontWeight: 800, color: '#0F172A', margin: 0, letterSpacing: '-0.01em' },
  editBtn: {
    display: 'flex', alignItems: 'center', gap: 6,
    fontSize: 12.5, fontWeight: 700, color: '#2563EB',
    background: '#EFF6FF', border: '1px solid #BFDBFE',
    borderRadius: 8, padding: '6px 14px', cursor: 'pointer',
  },

  profileAvatarWrap: { display: 'flex', alignItems: 'center', gap: 16, marginBottom: 24 },
  profileAvatar: {
    width: 64, height: 64, borderRadius: '50%',
    background: 'linear-gradient(135deg,#0D9488,#2563EB)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: 22, fontWeight: 800, color: '#fff', flexShrink: 0,
  },
  profileName:      { fontSize: 17, fontWeight: 800, color: '#0F172A', marginBottom: 6 },
  profileRoleBadge: {
    display: 'inline-block', fontSize: 11, fontWeight: 700,
    color: '#2563EB', background: '#EFF6FF', border: '1px solid #BFDBFE',
    padding: '3px 10px', borderRadius: 20, textTransform: 'uppercase', letterSpacing: '0.06em',
  },

  divider: { height: 1, background: '#F1F5F9', margin: '20px 0' },

  fieldList:    { display: 'flex', flexDirection: 'column', gap: 16 },
  fieldRow:     { display: 'flex', alignItems: 'flex-start', gap: 12 },
  fieldIcon: {
    width: 32, height: 32, borderRadius: 8, background: '#EFF6FF',
    border: '1px solid #BFDBFE', display: 'flex', alignItems: 'center',
    justifyContent: 'center', flexShrink: 0, marginTop: 2,
  },
  fieldContent: { flex: 1 },
  fieldLabel:   { fontSize: 11, fontWeight: 700, color: '#94A3B8', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 4 },
  fieldValue:   { fontSize: 14, fontWeight: 600, color: '#0F172A' },
  fieldInput: {
    width: '100%', padding: '8px 12px', border: '1.5px solid #E2E8F0',
    borderRadius: 8, fontSize: 13.5, color: '#0F172A', outline: 'none',
    background: '#F8FAFC', boxSizing: 'border-box', transition: 'border-color 0.2s',
  },

  quickLinks: { display: 'flex', flexDirection: 'column', gap: 10 },
  quickLink:  {
    display: 'flex', alignItems: 'center', gap: 10,
    fontSize: 13.5, fontWeight: 600, color: '#2563EB', textDecoration: 'none',
    padding: '10px 14px', borderRadius: 10, border: '1px solid #E2E8F0',
    background: '#F8FAFC', transition: 'background 0.18s',
  },

  /* Programs */
  sectionRow:   { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 18 },
  sectionTitle: { fontSize: 18, fontWeight: 800, color: '#0F172A', letterSpacing: '-0.02em', margin: 0 },
  viewAll:      { fontSize: 13, fontWeight: 700, color: '#2563EB', textDecoration: 'none' },
  programGrid:  { display: 'grid', gridTemplateColumns: 'repeat(2,1fr)', gap: 16 },
  programCard: {
    background: '#fff', border: '1.5px solid #E2E8F0', borderRadius: 14,
    overflow: 'hidden', textDecoration: 'none',
    boxShadow: '0 2px 8px rgba(0,0,0,0.05)', transition: 'all 0.2s',
  },
  programAccent: { height: 4, background: 'linear-gradient(90deg,#0D9488,#2563EB)' },
  programBody:   { padding: '16px 18px 18px' },
  programDuration: {
    fontSize: 10, fontWeight: 700, color: '#2563EB', background: '#EFF6FF',
    padding: '3px 10px', borderRadius: 20, display: 'inline-block',
    letterSpacing: '0.04em', textTransform: 'uppercase', marginBottom: 8,
  },
  programName:   { fontSize: 14, fontWeight: 800, color: '#0F172A', margin: '0 0 12px', lineHeight: 1.3 },
  programFooter: { display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
  programCost:   { fontSize: 15, fontWeight: 800, color: '#2563EB' },
  programLink:   { fontSize: 12, fontWeight: 600, color: '#2563EB' },
};

export default StudentDashboard;
